<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>用户名：</label>
                        <el-input v-model="search_Obj.f_user_name" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>姓名：</label>
                        <el-input v-model="search_Obj.f_real_name" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>平台端：</label>
                        <el-select v-model="search_Obj.f_ltype" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('platform_type')" :key="'cty'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>登录时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="dateRangeSet"
                            style="width:320px">
                        </el-date-picker>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="user_name" label="用户名" sortable="custom"></el-table-column>
                        <el-table-column prop="real_name" label="姓名" sortable="custom"></el-table-column>
                        <el-table-column prop="ltype" label="平台端" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.ltype, "platform_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="addtime" label="登录时间" sortable="custom"></el-table-column>
                        <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看登录日志"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'loginLogList',
    mixins: [listutil],
    components: {Info, Btns, LabBtns},
    data() {
        return {
            m_name: '登录日志',
            menu_id: 1900,
            list_url: "/api/admin/loginlog/list",
            search_Obj: {
                f_user_name: '',
                f_ltype: '',
                f_addtime_s_date: '',
                f_addtime_e_date: '',
            },
            del_Obj:{
                url:'/api/admin/loginlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['platform_type'],
            dateRange: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_addtime_s_date = val[0]
                this.search_Obj.f_addtime_e_date = val[1]
            }else{
                this.search_Obj.f_addtime_s_date = ''
                this.search_Obj.f_addtime_e_date = ''
            }
        },
    }
};
</script>